import React, { useState, useEffect, useRef } from 'react';
import styles from './BlogGrid.module.scss';
import { Typography } from '@mui/material';
import Image from 'next/image';
import { CountryDropdown, LinkArrow } from '../../../../../commons/hoc';
import PaginationComponent from '../../../account/components/Pagination/Pagination';
import { getObjFrmArray } from '../../../../../commons/utils/utils';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { config } from '../../../../../config';

export const BlogCard = ({
  size,
  item,
  categoryCB,
  currentPathname,
  className = '',
}) => {
  return (
    <div className={`${styles.blogItemContainer} ${className} ${styles[size]}`}>
      <div className={`${styles.blogCardImg} ${styles[size]}`}>
        <Link
          href={`/${currentPathname}/${item.category_collection[0].slug}/${item.slug}`}
        >
          <a>
            <Image
              src={item.featured_image?.url}
              layout="fill"
              className={styles.cardImg}
              blurDataURL={item.featured_image?.url}
              alt={item?.title}
              placeholder="blur"
            />
          </a>
        </Link>
      </div>
      <div className={styles.blogCardContent}>
        <div className={styles.blogCardTitle}>
          {item.category_collection?.map((item, i) => (
            <Link href={`/${currentPathname}/category/${item.slug}`}>
              <a
                key={i}
                className={styles.blogCategoryBtn}
                onClick={() => categoryCB(item.term_id)}
              >
                <Typography variant="h5" color="primary">
                  {item.name}
                </Typography>
              </a>
            </Link>
          ))}
          <Link
            href={`/${currentPathname}/${item.category_collection[0]?.slug}/${item.slug}`}
          >
            <a>
              <Typography
                variant="h3"
                color="primary"
                className={styles.articleLink}
              >
                {item.title}
              </Typography>
            </a>
          </Link>
        </div>
        <div className={styles.blogBtn}>
          <LinkArrow
            href={`/${currentPathname}/${item.category_collection[0]?.slug}/${item.slug}`}
          >
            Read Article
          </LinkArrow>
        </div>
      </div>
    </div>
  );
};

export default function BlogGrid({
  allCategories,
  currentCategory,
  currentTag,
  posts,
  totalCount,
}) {
  const router = useRouter();
  const [currentPage, setCurrentPage] = useState(router.query.page || 1);
  const [activeBtn, setActiveBtn] = useState(0);
  const pagePerItems = config.resources.item_per_page;
  const currentPathname = router.pathname.split('/')[1];
  const tabButton = useRef(null);
  const hasSpecialCharacters =
    /[a-zA-Z]/.test(currentPage) || /[^\w\s]/.test(currentPage);
  const maxLength = typeof currentPage == 'string' && currentPage.length > 10;

  useEffect(() => {
    if (currentCategory) {
      if (typeof currentCategory?.id != 'undefined') {
        setActiveBtn(currentCategory?.id);
      }
      tabButton.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    }
  }, [currentCategory, currentTag]);

  const updatedCategory = allCategories?.filter((object) => {
    return object.count != 0;
  });

  const category = [...updatedCategory];
  const allCategory = {
    id: 0,
    name: 'All Articles',
  };
  category.sort((a, b) => a.name.localeCompare(b.name));
  category.unshift(allCategory);

  const handleCategory = (id) => {
    if (id != 0) {
      router.push(
        `/${currentPathname}/category/${
          getObjFrmArray(allCategories, 'id', id).slug
        }`,
        undefined,
        {
          scroll: false,
        }
      );
      setActiveBtn(id);
    } else {
      router.push(`/${currentPathname}`);
      setActiveBtn(0);
    }
  };

  const handelRead = (item) => {
    const categoryId = item.category_collection[0];
    router.push(
      `/${currentPathname}/${
        getObjFrmArray(allCategories, 'id', categoryId.term_id).slug
      }/${item.slug}`,
      undefined,
      {
        shallow: true,
      }
    );
  };

  const handlePaginationCall = (currentPage) => {
    router.replace(
      {
        pathname: router.pathname,
        query: { ...router.query, page: currentPage },
      },
      undefined,
      { scroll: false }
    );
    setCurrentPage(currentPage);
    tabButton.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    });
  };

  const isOdd = (num) => {
    if (num % 2 == 1) {
      return true;
    }
    return false;
  };

  return (
    <div className={styles.gridWrapper}>
      <div className={styles.gridContainer} ref={tabButton}>
        {!currentTag && (
          <div className={`${styles.tabBtnWrapper} ${styles.blogTabBtn}`}>
            <div className={styles.tabBtnContainer}>
              {category.map((item, i) => (
                <Link
                  key={i}
                  href={
                    i != 0
                      ? `/${currentPathname}/category/${
                          getObjFrmArray(allCategories, 'id', item.id).slug
                        }`
                      : `/${currentPathname}`
                  }
                >
                  <a
                    className={`${styles.tabBtn} ${
                      activeBtn == item.id && styles.active
                    }`}
                  >
                    <Typography variant="button1">{item.name}</Typography>
                  </a>
                </Link>
              ))}
            </div>
          </div>
        )}
        {!currentTag && (
          <div className={styles.categoryContainer}>
            <div className={styles.categoryDropdownContainer}>
              <div className={styles.categoryDropdownFieldContainer}>
                <CountryDropdown
                  options={category.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                  value={currentCategory?.id}
                  tkey="label"
                  onChange={(e) => {
                    handleCategory(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        )}
        <div>
          <div className={styles.gridContentWrapper}>
            <div className={styles.gridContentContainer}>
              <div className={styles.blogCOntentDesktop}>
                <div
                  className={
                    currentCategory || currentTag
                      ? `${styles.relatedArticle}`
                      : `${styles.blogItemWrapper}`
                  }
                >
                  {!hasSpecialCharacters &&
                    !maxLength &&
                    posts?.map((item, i) => (
                      <BlogCard
                        key={i}
                        size={
                          currentTag || currentCategory
                            ? isOdd(i)
                              ? 'medium'
                              : 'small'
                            : [0, 1].includes(i)
                              ? 'large'
                              : isOdd(i)
                                ? 'medium'
                                : 'small'
                        }
                        item={item}
                        categoryCB={handleCategory}
                        readCB={handelRead}
                        category={allCategories}
                        currentPathname={currentPathname}
                      />
                    ))}
                </div>
              </div>
              {(hasSpecialCharacters || maxLength || posts.length == 0) && (
                <div className={styles.noArticlesContainer}>
                  <Typography variant="h4">
                    No related articles found
                  </Typography>
                </div>
              )}
              <div className={styles.blogCOntentTab}>
                <div
                  className={
                    currentCategory || currentTag
                      ? `${styles.relatedArticle}`
                      : `${styles.blogItemWrapper}`
                  }
                >
                  {!hasSpecialCharacters &&
                    !maxLength &&
                    posts?.map((item, i) => (
                      <BlogCard
                        key={i}
                        size={
                          currentTag || currentCategory
                            ? isOdd(i)
                              ? 'medium'
                              : 'small'
                            : [0].includes(i)
                              ? 'large'
                              : isOdd(i)
                                ? 'small'
                                : 'medium'
                        }
                        item={item}
                        categoryCB={handleCategory}
                        readCB={handelRead}
                        category={allCategories}
                        currentPathname={currentPathname}
                      />
                    ))}
                </div>
              </div>
              <div className={styles.blogCOntentMobile}>
                <div className={styles.blogItemWrapper}>
                  {!hasSpecialCharacters &&
                    !maxLength &&
                    posts?.map((item, i) => (
                      <BlogCard
                        key={i}
                        size={isOdd(i) ? 'small' : 'medium'}
                        item={item}
                        categoryCB={handleCategory}
                        readCB={handelRead}
                        category={allCategories}
                        currentPathname={currentPathname}
                      />
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.blogPagination}>
          {!hasSpecialCharacters && !maxLength && posts.length > 0 && (
            <PaginationComponent
              handlePaginationCall={handlePaginationCall}
              totalCounts={totalCount}
              itemsPerPages={pagePerItems}
              maxPageNumberLimits={3}
              minPageNumberLimits={0}
              pageNumberLimits={3}
              currentPages={currentPage}
            />
          )}
        </div>
      </div>
    </div>
  );
}
